import { Component } from '@angular/core';

import { TableCellBaseComponent } from '@wcg/frontend-framework';
import { FileUploadStatusComponent } from '@documents/file-upload-status/file-upload-status.component';

@Component({
  selector: 'wcg-document-upload-status-cell',
  imports: [FileUploadStatusComponent],
  templateUrl: './document-upload-status-cell.component.html',
  styleUrls: ['./document-upload-status-cell.component.css'],
})
export class DocumentUploadStatusCellComponent extends TableCellBaseComponent<any> {}
